import AddAdditionalState from '../../../Helpers/Lists/AddAdditionalState';

export default function GetStateListForAflac() {
  return  AddAdditionalState([{ label: "Guam", value: "GU" }]);
}